// ─────────────────────────────────────────────────────────────────────────────
// Clarity Strategy Manager — global application branding.
// Single source of truth for the product name across the entire frontend.
// If you need to rebrand, edit this file only.
// ─────────────────────────────────────────────────────────────────────────────
export const APP_NAME = 'Clarity Strategy Manager';
export const APP_SHORT_NAME = 'CSM';
export const APP_TAGLINE = 'Strategy Manager';
export const APP_PLATFORM_LABEL = 'Enterprise Strategy Platform';

const appConfig = { APP_NAME, APP_SHORT_NAME, APP_TAGLINE, APP_PLATFORM_LABEL };
export default appConfig;
